export let Delivery = /*#__PURE__*/function (Delivery) {
  Delivery["UNKNOWN_DELIVERY"] = "UNKNOWN_DELIVERY";
  Delivery["PUSH"] = "PUSH";
  Delivery["SYSTEM_MESSAGE"] = "SYSTEM_MESSAGE";
  Delivery["LEDGER"] = "LEDGER";
  Delivery["NONE"] = "NONE";
  return Delivery;
}({});
export let MessageRole = /*#__PURE__*/function (MessageRole) {
  MessageRole["UNKNOWN_MESSAGE_ROLE"] = "UNKNOWN_MESSAGE_ROLE";
  MessageRole["USER"] = "USER";
  MessageRole["ASSISTANT"] = "ASSISTANT";
  MessageRole["SYSTEM"] = "SYSTEM";
  MessageRole["TOOL_USE"] = "TOOL_USE";
  MessageRole["TOOL_RESULT"] = "TOOL_RESULT";
  MessageRole["THINKING"] = "THINKING";
  MessageRole["ASSISTANT_STEP"] = "ASSISTANT_STEP";
  return MessageRole;
}({});
export let CommunicationChannel = /*#__PURE__*/function (CommunicationChannel) {
  CommunicationChannel["UNKNOWN_COMMUNICATION_CHANNEL"] = "UNKNOWN_COMMUNICATION_CHANNEL";
  CommunicationChannel["APP"] = "APP";
  CommunicationChannel["WHATSAPP"] = "WHATSAPP";
  CommunicationChannel["SMS"] = "SMS";
  CommunicationChannel["EMAIL"] = "EMAIL";
  CommunicationChannel["TELEGRAM"] = "TELEGRAM";
  CommunicationChannel["WEB"] = "WEB";
  CommunicationChannel["VOICE"] = "VOICE";
  CommunicationChannel["EXTERNAL_AGENT"] = "EXTERNAL_AGENT";
  CommunicationChannel["PHONE_CALL"] = "PHONE_CALL";
  CommunicationChannel["GMAIL_CONNECTOR"] = "GMAIL_CONNECTOR";
  CommunicationChannel["INSTAGRAM_CONNECTOR"] = "INSTAGRAM_CONNECTOR";
  CommunicationChannel["CALENDAR_MEETINGS"] = "CALENDAR_MEETINGS";
  CommunicationChannel["WHATSAPP_CONNECTOR"] = "WHATSAPP_CONNECTOR";
  return CommunicationChannel;
}({});
export let ConversationSource = /*#__PURE__*/function (ConversationSource) {
  ConversationSource["UNKNOWN_CONVERSATION_SOURCE"] = "UNKNOWN_CONVERSATION_SOURCE";
  ConversationSource["SCHEDULER"] = "SCHEDULER";
  ConversationSource["BRAIN"] = "BRAIN";
  ConversationSource["PULSE"] = "PULSE";
  ConversationSource["SYMPHONY"] = "SYMPHONY";
  ConversationSource["BRIEF"] = "BRIEF";
  ConversationSource["SYSTEM"] = "SYSTEM";
  return ConversationSource;
}({});
export let SortOrder = /*#__PURE__*/function (SortOrder) {
  SortOrder["ASC"] = "ASC";
  SortOrder["DESC"] = "DESC";
  return SortOrder;
}({});
export let AggregationType = /*#__PURE__*/function (AggregationType) {
  AggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
  AggregationType["VALUE"] = "VALUE";
  AggregationType["RANGE"] = "RANGE";
  AggregationType["SCALAR"] = "SCALAR";
  AggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
  AggregationType["NESTED"] = "NESTED";
  return AggregationType;
}({});
export let Mode = /*#__PURE__*/function (Mode) {
  Mode["OR"] = "OR";
  Mode["AND"] = "AND";
  return Mode;
}({});
export let SortType = /*#__PURE__*/function (SortType) {
  SortType["COUNT"] = "COUNT";
  SortType["VALUE"] = "VALUE";
  return SortType;
}({});
export let SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection["DESC"] = "DESC";
  SortDirection["ASC"] = "ASC";
  return SortDirection;
}({});
export let MissingValues = /*#__PURE__*/function (MissingValues) {
  MissingValues["EXCLUDE"] = "EXCLUDE";
  MissingValues["INCLUDE"] = "INCLUDE";
  return MissingValues;
}({});
export let ScalarType = /*#__PURE__*/function (ScalarType) {
  ScalarType["UNKNOWN_SCALAR_TYPE"] = "UNKNOWN_SCALAR_TYPE";
  ScalarType["COUNT_DISTINCT"] = "COUNT_DISTINCT";
  ScalarType["MIN"] = "MIN";
  ScalarType["MAX"] = "MAX";
  ScalarType["SUM"] = "SUM";
  ScalarType["AVG"] = "AVG";
  return ScalarType;
}({});
export let Interval = /*#__PURE__*/function (Interval) {
  Interval["UNKNOWN_INTERVAL"] = "UNKNOWN_INTERVAL";
  Interval["YEAR"] = "YEAR";
  Interval["MONTH"] = "MONTH";
  Interval["WEEK"] = "WEEK";
  Interval["DAY"] = "DAY";
  Interval["HOUR"] = "HOUR";
  Interval["MINUTE"] = "MINUTE";
  Interval["SECOND"] = "SECOND";
  return Interval;
}({});
export let NestedAggregationType = /*#__PURE__*/function (NestedAggregationType) {
  NestedAggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
  NestedAggregationType["VALUE"] = "VALUE";
  NestedAggregationType["RANGE"] = "RANGE";
  NestedAggregationType["SCALAR"] = "SCALAR";
  NestedAggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
  return NestedAggregationType;
}({});